<template>
    <base-select
        v-model="innerValue"
        v-bind="$attrs"
        :options="optionsList"
        label="Company"
        name="Company"
        placeholder="Select Company"
    ></base-select>
</template>

<script>
import { defineComponent, computed, ref, watch, onMounted } from "@vue/composition-api";

import { useAuth } from "@composables/auth";
import Companies from "@services/Companies";

export default defineComponent({
    name: "CompaniesDropdown",
    emits: ["input", "error:noOptions"],
    props: {
        value: [String, Number],
        userCompanyAsOption: Boolean,
    },
    setup(props, { emit }) {
        const { currentUser } = useAuth();

        const companiesList = ref([]);

        const innerValue = computed({
            get: () => props.value,
            set: (newValue) => emit("input", newValue),
        });
        const optionsList = computed(() =>
            companiesList.value
                .filter((item) => "Active" == item.status)
                .map((item) => ({
                    value: item.id,
                    text: item.name,
                }))
        );

        const getCompanies = async () => {
            const resp = await Companies.getCompanies({ page_size: 1000 });

            companiesList.value = resp.data.data.results;
        };

        watch(
            () => companiesList.value,
            (newCompaniesList) => {
                if (!newCompaniesList.length) {
                    emit("error:noOptions", true);
                }
            }
        );

        onMounted(() => {
            if (props.userCompanyAsOption) {
                if (!currentUser.value.company) return false;

                companiesList.value.push({
                    ...currentUser.value.company,
                    active: true,
                });
            } else {
                getCompanies();
            }
        });

        return {
            innerValue,
            companiesList,
            optionsList,
        };
    },
});
</script>
